module.exports = __webpack_public_path__ + "img/3_4.47a15d31.png";